export default class VoucherQRCode {
    constructor() {
        this.id = undefined;
        this.code = undefined;
    }

    static assign(code, to) {
        if (code) {
            to.id = undefined;
            to.code = code;
        } else {
            to = new VoucherQRCode();
        }
    }

    static copy(code) {
        const to = new VoucherQRCode();
        VoucherQRCode.assign(code, to);
        return to;
    }
}
